<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/1.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/WechatIMG24.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/WechatIMG25.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/WechatIMG26.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/WechatIMG27.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title">快麦<span class="other-color">KM-360A</span>便携打印机</div>
                    <div class="sub-title">2000mAh可充电电池，5-7天不休眠</div>
                    <div class="text">
                        通讯接口：蓝牙<br/>
                        打印速度：max80mm/s<br/>
                        打印宽度：max72m<br/>
                        适用：快递员、果蔬等户外打印快递面单
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/KM-360A_02.jpg" alt="bg">
                <img src="./images/KM-360A_03.jpg" alt="bg">
                <img src="./images/KM-360A_04.jpg" alt="bg">
                <img src="./images/KM-360A_05.jpg" alt="bg">
                <img src="./images/KM-360A_06.jpg" alt="bg">
                <img src="./images/KM-360A_07.jpg" alt="bg">
                <img src="./images/KM-360A_08.jpg" alt="bg">
                <img src="./images/KM-360A_09.jpg" alt="bg">
                <img src="./images/KM-360A_10.jpg" alt="bg">
                <img src="./images/KM-360A_11.jpg" alt="bg">
                <img src="./images/KM-360A_12.jpg" alt="bg">
                <img src="./images/KM-360A_13.jpg" alt="bg">
                <img src="./images/KM-360A_14.jpg" alt="bg">
                <img src="./images/KM-360A_15.jpg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="content-bg-cs"></div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }

    .content-bg-cs {
    }
}
</style>
